import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {Periodo} from "../../../_models/interfaces";
import {NavBarObject} from "../../../_components/nav-bar/config";
import {EstudioService} from "../estudio.service";

@Component({
    selector: 'materias-familia',
    standalone: false,
    templateUrl: 'materias-familia.component.html'
})

export class MateriasFamiliaComponent implements OnInit, OnDestroy {

    periodosNavBar: NavBarObject[];

    materias: any[] = [];
    hashFragment: string;

    hijoID;

    subscriptions = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private titleService: Title,
                private estudioService: EstudioService) {
    }

    ngOnInit() {
        let hijoID = this.hijoID = this.route.parent.snapshot.paramMap.get('hijoID'),
            periodoID = +this.route.snapshot.paramMap.get('periodoID');


        const subscriptionMain = this.route.parent.data.subscribe((data: { periodos: Periodo[] }) => {
            const periodo = data.periodos[0];
            if ( periodoID === 0 ) {
              periodoID = periodo.id;
            }
            this.periodosNavBar = [new NavBarObject(
                periodo.nombre,
                [`/estudio/familia/alumno/${hijoID}/materias/periodo/${periodoID}`],
                periodo.id,
                [new NavBarObject('Acumulado', [`/estudio/familia/alumno/${hijoID}/materias/periodo/${periodo.id}`], periodo.id)].concat(
                    periodo.periodos.map((child, i) => {
                        // if (!this.periodoSeleccionado){ /*&& periodo.periodos.length - 1 == i) {*/
                        //     this.periodoSeleccionado = periodo.id;
                        // }
                        if (child.tipo < 2) {
                            return new NavBarObject(`Periodo ${child.nombre}`, [`/estudio/familia/alumno/${hijoID}/materias/periodo/${child.id}`], child.id)
                        } else {
                            return false;
                        }
                    }))
            )];



            const subscriptionFragment = this.route.fragment.subscribe(fragment => {
              this.hashFragment = fragment
            });
            this.subscriptions.push(subscriptionFragment);
            const subscriptionParams = this.route.parent.params.subscribe(params => {
              this.materias = [];
              this.hijoID = params.hijoID;
              const subscriptionHijos = this.estudioService.getMateriasHijo(this.hijoID, periodoID).subscribe(res => {
                  this.materias = this.estudioService.extractData(res);
                  this.goToHash();
              });
              this.subscriptions.push(subscriptionHijos);
            });
            this.subscriptions.push(subscriptionParams);
            const subscriptionMateria = this.route.params.subscribe(params => {
                this.materias = [];
                const subscriptionHijos = this.estudioService.getMateriasHijo(hijoID, periodoID).subscribe(res => {
                    this.materias = this.estudioService.extractData(res);
                    this.goToHash();
                });
                this.subscriptions.push(subscriptionHijos);
            });
            this.subscriptions.push(subscriptionMateria);
        });
        this.subscriptions.push(subscriptionMain);
        this.titleService.setTitle('Materias');
    }

    ngOnDestroy(): void {
      this.subscriptions.forEach(item => {
        item.unsubscribe();
      })
    }

    goToHash() {
        let cmp = document.getElementById(`${this.hashFragment}`);
        window.scrollTo(0, 0);
        if (cmp) {
            cmp.scrollIntoView();
        }else{
            window.scrollTo(0, 0);
        }
    }
}
